import React, { useState } from "react";

import Header from "../../Header";
import PhoneValue from "../../PhoneInput/PhoneInput";
import ModalSelect from "../../ModalSelect/ModalSelect";

import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useSessionStorage } from "usehooks-ts";
import { useNavigate } from "react-router";

function ManagerNewProrab() {
  const [phoneValue, setPhoneValue] = useSessionStorage("phoneValue");
  const [nameValue, setNameValue] = useSessionStorage("nameValue", null);

  const selectedAddresses = useSelector(
    (state) => state.manager.selectedAddresses
  );

  const navigate = useNavigate();

  const makeRightReg = () => {
    if (selectedAddresses.size === 1) {
      return `Выбран ${selectedAddresses.size} адрес`;
    } else if (selectedAddresses.size <= 4) {
      return `Выбрано ${selectedAddresses.size} адреса`;
    } else if (selectedAddresses.size >= 5) {
      return `Выбрано ${selectedAddresses.size} адресов`;
    }
  };

  async function createProrab() {
    try {
      const response = await fetch(
        `https://api-erkon.tech/mobile/hs/ObmenMP/AddProrabPWA`,
        {
          method: "POST",
          headers: {
            token: localStorage.getItem("tokenMANAGER"),
          },
          body: JSON.stringify({
            name: nameValue,
            telefon: phoneValue,
            AdressList: Array.from(selectedAddresses),
          }),
        }
      );

      if (response.status === 200) {
        toast.success("Прораб успешно добавлен");
        setTimeout(() => {
          navigate("/requests");
        }, 1000);
        return;
      }
    } catch (e) {
      toast.error("Ошибка удаления прораба");
    }
  }

  const alertEmptyFields = () => {
    if (selectedAddresses.size === 0) {
      toast.error("Нужно заполнить список адресов");
    } else if (phoneValue?.length !== 17) {
      toast.error("Заполните номер телефона прораба");
    }
  };

  return (
    <>
      <Header headerTitle={"Новый прораб"} backRedirect={-1} />
      <div className="addressAndTime">
        <span className="titleRequestMenu">
          Подключите адреса<span style={{ color: "#FF3D3D" }}>*</span>
        </span>
        <div className="addressAndTimeContent">
          <ModalSelect
            selectTitle={"Выберите адреса"}
            selectedInformation={
              selectedAddresses.size !== 0 ? makeRightReg() : null
            }
          />
        </div>
      </div>
      <div className="addressAndTime">
        <span className="titleRequestMenu">
          Имя пользователя<span style={{ color: "#FF3D3D" }}>*</span>
        </span>
        <div className="addressAndTimeContent">
          <input
            style={input}
            placeholder="Введите имя"
            value={nameValue}
            onChange={(event) => setNameValue(event.target.value)}
            type="text"
          />
        </div>
      </div>
      <div className="addressAndTime">
        <span className="titleRequestMenu">
          Телефон пользователя<span style={{ color: "#FF3D3D" }}>*</span>
        </span>
        <div className="addressAndTimeContent">
          <PhoneValue phoneValue={phoneValue} setPhoneValue={setPhoneValue} />
        </div>
      </div>
      <div className="footerSendButtonAddress">
        <div className="sendButtonPlaceholder">
          <button
            onClick={
              selectedAddresses.size !== 0 && phoneValue?.length === 17
                ? () => createProrab()
                : () => alertEmptyFields()
            }
            className="sendButtonActive"
          >
            Добавить прораба
          </button>
        </div>
      </div>
    </>
  );
}

const input = {
  display: "flex",
  height: "3.75rem",
  padding: "0.625rem 1rem",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  alignSelf: "stretch",
  borderRadius: "0.5rem",
  background: "var(--Colors-plashka_parametr, rgba(116, 116, 128, 0.08))",
  color: "#8a8a8e",
  overflow: "hidden",
  fontFamily: "'Inter', sans-serif",
  fontFeatureSettings: '"case" on',
  textOverflow: "ellipsis",
  fontSize: "1.1rem",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "1.5rem",
};

export default ManagerNewProrab;
